import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import scrollTo from 'simple-scrollTo';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-progress-detail', {
  mixins: [eventListenerMixin],

  properties: {
    statusId: {
      type: String,
      default: '',
    },
  },

  connected() {
    if (this.statusId) {
      this.scrollToStatus(this.statusId);
    }
  },

  scrollToStatus(statusId) {
    const container = document.querySelector('tr-fullscreen-overlay .overlay-container');
    const selector = `.project-actions .streams .event-project-update_status[data-status-id="${statusId}"] .project-status-title`;
    const status = this.querySelector(selector);
    if (status) $(status).click();

    if (container) {
      setTimeout(() => {
        scrollTo({
          target: $(status),
          container: $(container),
          animation: false,
          offset: { y: 84, x: 0 },
        });
      });
    } else {
      setTimeout(() => {
        scrollTo({
          target: $(status),
          animation: false,
          offset: { y: 84, x: 0 },
        });
      });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
